import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

export default function Research(){

return(

<div className="app-shell">

<Navbar/>

<section className="page-section">
<div className="section-shell px-6">
<div className="content-card page-copy rounded-[2rem] p-8 md:p-12">

<div className="eyebrow">Research</div>

<h1 className="mb-6 mt-6 text-4xl font-bold text-stone-900 md:text-5xl">

Research Overview

</h1>

<p>

This project proposes an AI-driven system for real-time
sign language translation using CNN and MediaPipe.

</p>

<h2 className="mt-8 text-2xl text-stone-900">

Methodology

</h2>

<p>

Hand gestures are detected using MediaPipe and classified
with a deep learning CNN model.

</p>

<h2 className="mt-8 text-2xl text-stone-900">

Results

</h2>

<p>

The model achieves high accuracy for sign recognition
in real-time environments.

</p>

</div>
</div>
</section>

<Footer/>

</div>

)

}
